<template>
  <qx-card title="列表">
    <UploadFileDialog ref="uploadFileDialog" />
    <LogRightDialog ref="logRightDialog" busiCode="21000022" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1003030101">
        <el-button
          type="primary"
          plain
          @click="() => toAddNew(1, '司机出车借支')"
          >司机出车借支</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="1003030102">
        <el-button
          type="primary"
          plain
          @click="() => toAddNew(2, '车辆维护借支')"
          >车辆维护借支</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="1003030103">
        <el-button type="primary" plain @click="() => toAddNew(3, '员工借支')"
          >员工借支</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions="1003030108">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="oaLoan.ajax?cmd=queryOaLoanPageList"
          :params="fullSearchData"
          bizName="借支管理数据导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'oaLoanId'"
                  @click="toDetail(scope.row, '借支详情')"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-if="scope.column.property === 'loanSubjectName'">
                  <span
                    class="text-loanSubjectName exceed-ellipsis"
                    :title="scope.row[scope.column.property]"
                    >{{ scope.row[scope.column.property] }}</span
                  >
                </section>
                <section
                  v-if="
                    scope.column.property !== 'oaLoanId' &&
                    scope.column.property !== 'loanSubjectName'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <el-table-column
            prop="text-exceed"
            label="操作"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <!-- {
                  showCondition: scope.row.sts >= 3 && scope.row.sts !== 8,
                  name: '上传附件',
                  event: () => showUploadFileDialog(scope.row),
              },-->
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1003030104',
                    showCondition:
                      scope.row.isHasPermission &&
                      (scope.row.sts === 1 || scope.row.sts === 0),
                    name: '审核',
                    event: () => toDetail(scope.row, '审核借支', 'approve'),
                  },
                  {
                    permpisions: '1003030105',
                    showCondition:
                      scope.row.launch === 1 &&
                      (scope.row.sts === 0 || scope.row.sts === 2),
                    name: '修改',
                    event: () => toEdit(scope.row),
                  },
                  {
                    permpisions: '1003030106',
                    showCondition: scope.row.sts === 3 || scope.row.sts === 4,
                    name: '核销',
                    event: () =>
                      toDetail(scope.row, '借支核销', 'cancellation'),
                  },
                  {
                    permpisions: '1003030107',
                    showCondition: scope.row.sts >= 3 && scope.row.sts !== 8,
                    name: '上传附件',
                    event: () => showUploadFileDialog(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.LId),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import TableBtn from 'components/tableBtn/tableBtn';
import LogRightDialog from 'components/logRightDialog';
import UploadFileDialog from './uploadFileDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  queryOaLoanPageList,
} from 'api/cost';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    TableBtn,
    LogRightDialog,
    UploadFileDialog,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'oaLoanId', label: '借支单号', fixed: true },
          { prop: 'userName', label: '申请人' },
          { prop: 'mobilePhone', label: '手机号码' },
          { prop: 'loanTypeName', label: '借支类型', w: 120 },
          { prop: 'loanSubjectName', label: '借款用途', w: 120, slot: true },
          { prop: 'appDate', label: '申请时间' },
          { prop: 'plateNumber', label: '车牌号码' },
          { prop: 'accName', label: '收款人' },
          { prop: 'x', label: '收款账户' },
          { prop: 'orgName', label: '收款人归属部门' },
          { prop: 'amountDouble', label: '借支金额' },
          { prop: 'payedAmountDouble', label: '已核销金额' },
          { prop: 'flowId', label: '支付流水号' },
          { prop: 'stateName', label: '借支状态' },
          { prop: 'xx', label: '借支说明' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryOaLoanPageList,
    showUploadFileDialog (item) {
      this.$refs.uploadFileDialog.show(item);
    },
    toAddNew (loanType, label) {
      this.jump({
        label,
        url: `/manage/cost/borrow/manage/edit?type=add&loanType=${loanType}`,
        full: true,
      });
    },
    toEdit (item) {
      this.jump({
        label: `修改借支-${item.oaLoanId}`,
        url: `/manage/cost/borrow/manage/edit?type=edit&loanType=${item.loanType}&id=${item.LId}`,
        full: true,
      });
    },
    toDetail (item, label, type = '') {
      this.jump({
        label,
        url: `/manage/cost/borrow/manage/detail?id=${item.LId}&type=${type}&loanType=${item.loanType}`,
        full: true,
      });
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-loanSubjectName {
  display: inline-block;
  width: 110px;
}
</style>
